export const serialize = (form: HTMLFormElement) => {
  const entries = new FormData(form).entries();

  return Object.fromEntries(entries);
};
